const TransferRole = {
  isPlayer: 1,
  isCoach: 2,
};

export {TransferRole};
